import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
}));

export default useStyles;
